<template>
  <div class="info-card">
    <h3 class="card-header"><i class="fas fa-info-circle"></i> Session Details</h3>
    <div class="info-content">
      <div class="info-item">
        <span class="label"><i class="fas fa-language"></i> Languages:</span>
        <span class="value">{{ instructor.languages || 'Not specified' }}</span>
      </div>
      <div class="info-item">
        <span class="label"><i class="fas fa-dollar-sign"></i> Price per Session:</span>
        <span class="value">${{ instructor.price_per_session || '0.00' }}</span>
      </div>
      <div class="info-item">
        <span class="label"><i class="fas fa-clock"></i> Duration:</span>
        <span class="value">{{ instructor.session_duration || '0' }} minutes</span>
      </div>
      <div class="info-item">
        <span class="label"><i class="fas fa-check-circle"></i> Availability:</span>
        <span class="value" :class="{ 'available': instructor.is_available, 'unavailable': !instructor.is_available }">
          {{ instructor.is_available ? 'Available' : 'Not Available' }}
        </span>
      </div>
      <div class="info-item">
        <span class="label"><i class="fas fa-globe"></i> Timezone:</span>
        <span class="value">{{ instructor.timezone || 'Not specified' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InstructorSessionInfo',
  props: {
    instructor: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.info-card {
  background: white;
  border-radius: 0.75rem;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 1.5rem;
}

.card-header {
  background: #f8fafc;
  color: #1e293b;
  padding: 1rem 1.5rem;
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.card-header i {
  color: #3b82f6;
}

.info-content {
  padding: 1.25rem 1.5rem;
}

.info-item {
  display: flex;
  justify-content: space-between;
  padding: 0.75rem 0;
  border-bottom: 1px solid #f1f5f9;
}

.info-item:last-child {
  border-bottom: none;
}

.label {
  color: #64748b;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.value {
  font-weight: 500;
  color: #1e293b;
}

.value.available {
  color: #16a34a;
}

.value.unavailable {
  color: #ef4444;
}
</style> 